module.exports = __webpack_public_path__ + "img/facts-foodandbeverage.04b38d9f.png";